import { render, staticRenderFns } from "./LoaderWrapper.vue?vue&type=template&id=108f4559"
import script from "./LoaderWrapper.vue?vue&type=script&lang=js"
export * from "./LoaderWrapper.vue?vue&type=script&lang=js"
import style0 from "./LoaderWrapper.vue?vue&type=style&index=0&id=108f4559&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports